import type { Currency } from '@/domains/core/localization/interfaces/Currency';
import type { Platform } from '@/domains/core/settings/interfaces/Platform';

const platformMap = {
  es: 'EUR',
  fr: 'EUR',
  gb: 'GBP',
  de: 'EUR',
  it: 'EUR',
} as { [key in Platform]: Currency };

export function getPlatformCurrency(platform: Platform): Currency {
  return platformMap[platform];
}
